import * as React from "react";
import { cn } from "@/lib/utils";
import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "./ui/navigation-menu";

const treatmentItems: { title: string; href: string; description: string }[] = [
  {
    title: "Erectile Dysfunction",
    href: "/treatments/mens-health/erectile-dysfunction",
    description: "Learn about our advanced treatments for ED.",
  },
  {
    title: "Neuropathy",
    href: "/treatments/neuropathy",
    description: "Explore effective solutions for neuropathy.",
  },
  {
    title: "Soft Tissue",
    href: "/treatments/soft-tissue",
    description: "Treats plantar fasciitis, tennis elbow, and more.",
  },
  {
    title: "Aesthetics",
    href: "/treatments/aesthetics",
    description: "Transform your skin with advanced shockwave therapy.",
  },
];

const moreItems: { title: string; href: string; description: string }[] = [
  {
    title: "Research",
    href: "/research",
    description: "Discover the research behind our treatments.",
  },
  {
    title: "Reviews",
    href: "/reviews",
    description: "Read testimonials from our patients.",
  },
  {
    title: "Contact Us",
    href: "/contact-us",
    description: "Get in touch with our team.",
  },
];

export const TreatmentsMenu = () => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-accent text-sm font-medium">
        Treatments
      </NavigationMenuTrigger>
      <NavigationMenuContent>
        <ul className="grid gap-3 p-4 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr]">
          {treatmentItems.map((item) => (
            <ListItem key={item.title} title={item.title} href={item.href}>
              {item.description}
            </ListItem>
          ))}
        </ul>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};

export const MoreMenu = () => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-accent text-sm font-medium">
        More
      </NavigationMenuTrigger>
      <NavigationMenuContent>
        <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px] ">
          {moreItems.map((item) => (
            <ListItem key={item.title} title={item.title} href={item.href}>
              {item.description}
            </ListItem>
          ))}
        </ul>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};

const ListItem = React.forwardRef<
  React.ElementRef<"a">,
  React.ComponentPropsWithoutRef<"a">
>(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
            className,
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = "ListItem";
